import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { TrashIcon } from 'components/icons';
import { DeleteGatewayModalProps } from './types';

export function DeleteGatewayModal(
  props: DeleteGatewayModalProps,
): ReactElement {
  const { isOpen, onCancel, onConfirm, gateway } = props;

  const onAction = (): void => {
    onConfirm?.(gateway);
  };

  return (
    <Modal
      open={isOpen}
      setOpen={onCancel}
      size="xs"
      title={`Delete "${gateway?.name}" Gateway?`}
      titleAlignment="center"
      textAlignment="center"
      onAction={onAction}
      actionText="Delete Gateway"
      actionButtonTheme="danger"
      actionIcon={TrashIcon}
    />
  );
}
